.preloader {
  width: 100%;
  height: 100%;
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: rgb(255 255 255 / 70%);
  font-size: 5rem;
  z-index: 2;
}
